const PRODUCTION_FRONTEND_URL = 'https://app.stable-funds.com';
const PRODUCTION_BACKEND_URL = 'https://backend.stable-funds.com';
const LOCAL_FRONTEND_URL = 'http://localhost:3000';
const LOCAL_BACKEND_URL = 'http://localhost:5000';

const stripTrailingSlash = (value = '') => value.replace(/\/+$/, '');

const getDefaultFrontendUrl = () =>
  process.env.NODE_ENV === 'production' ? PRODUCTION_FRONTEND_URL : LOCAL_FRONTEND_URL;

const getDefaultBackendUrl = () =>
  process.env.NODE_ENV === 'production' ? PRODUCTION_BACKEND_URL : LOCAL_BACKEND_URL;

export const getFrontendBaseUrl = () =>
  stripTrailingSlash(process.env.REACT_APP_FRONTEND_URL || getDefaultFrontendUrl());

export const getBackendBaseUrl = () =>
  stripTrailingSlash(process.env.REACT_APP_BACKEND_URL || getDefaultBackendUrl());

export const getApiBaseUrl = () =>
  stripTrailingSlash(process.env.REACT_APP_API_URL || `${getBackendBaseUrl()}/api`);

export const getSocketBaseUrl = () => getApiBaseUrl().replace(/\/api$/, '');

export const FRONTEND_APP_URL = getFrontendBaseUrl();
export const BACKEND_APP_URL = getBackendBaseUrl();
